<template>
  <div class="ui-find" :class="{'ui-findx':iphonex }">
    <router-link :to="{path:'category',query: queryString}" class="nav-item" v-if="hasCategoryTab">
      <img
        src="https://img12.360buyimg.com/jrpmobile/jfs/t28558/341/584309050/5991/b8ba7fae/5bf7a334N5709b591.png"
      >
    </router-link>
    <div v-else class="nav-item"></div>
    <div @click="gotoJdd" to="/DiscoverPage" class="nav-item">
      <img
        src="https://img12.360buyimg.com/jrpmobile/jfs/t28900/18/565124660/5468/90a6a63b/5bf7a198Nd2b9c0f7.png"
      >
    </div>
    <router-link :to="{path:'me',query: {nav: 'jd'}}" class="nav-item">
      <img
        src="https://img12.360buyimg.com/jrpmobile/jfs/t27190/282/2064470852/1681/6accb1e6/5bf7a1f1N3b206ca1.png"
      >
    </router-link>
  </div>
</template>
<script>
import { isIphonex, getStaticConfig } from '@/util/common';
import { getQuery } from '@/util/url';
let hasCategoryTab = false;
try {
  hasCategoryTab = getStaticConfig('hasCategoryTab');
} catch (error) {
  console.log(error);
}
export default {
  name: 'FindCenter',
  data() {
    return {
      iphonex: isIphonex() ? true : false,
      queryString: {},
      hasCategoryTab
    };
  },
  computed: {},
  methods:{
      gotoJdd(){
          var arg="";
          if(location.search!=""){
              try{
                  var searchs=location.search.substring(1,location.search.length).split("&");
                  for(var i=0;i<searchs.length;i++){
                      if(searchs[i].indexOf("channel")!=-1){
                            arg=searchs[i];
                            break;
                      }
                  }
              }catch(e){}
          }
          if(arg!=""){
              arg="&"+arg;
          }
          location.href="https://jddx.jd.com/m/jdd/index.html?from=mxxq"+arg
      }
  },
  created() {
    this.queryString = getQuery();
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss" scoped>
@import './../scss/mixin.scss';
.ui-find {
  position: fixed;
  right: $rem14;
  bottom: $rem120;
  width: $rem116;
  height: $rem348;
  float: right;
  z-index: 100;

  .nav-item {
    display: block;
    width: $rem116;
    height: $rem116;
    overflow: hidden;
  }

  img {
    width: 100%;
  }
}
.ui-findx {
  bottom: $rem170;
}
</style>
